import { LoyaltyStatusEnum } from 'app/models';

export class LoyaltyStatusesModel {
    public static LoyaltyStatusList: Array<any> = [
        { value: LoyaltyStatusEnum.All, name: 'All' },
        { value: LoyaltyStatusEnum.Active, name: 'Active' },
        { value: LoyaltyStatusEnum.Upcoming, name: 'Upcoming' },
        { value: LoyaltyStatusEnum.Draft, name: 'Draft' },
        { value: LoyaltyStatusEnum.Disabled, name: 'Disabled' },
        { value: LoyaltyStatusEnum.Ended, name: 'Ended' }
    ];
}
